import api from "../../Api/feathers-client";

export const getClassWiseInsights = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("classwise-insights").find(params);
      resolve({
        status: 200,
        message: "Class Wise insights data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
export const getAssignmentData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find({
        query: {
          $select: ["uid", "site_uuid", "commences", "expiries", "title", "tasks"],
          uid: params.assignment_ids,
          site_uuid: params.site_uuid,
          $sort: {
            createdAt: -1,
          },
          $limit: -1,
        }
      });
      resolve({
        status: 200,
        message: "Class Wise insights assignments data",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

